export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openGrid({commit}) {
        commit('setGridOpen');
    },
    openDataAssInvForm({commit}) {
        commit('setDataAssInvFormOpen');
    },
    openDataAssInvGrid({commit}) {
        commit('setDataAssInvGridOpen');
    }
}
